<template>
  <div id="preview" v-loading="showLoading">
    <div class="chapter" id="chapter" @click="handleSael">
      <img v-if="show" :src="chapter_" alt="" />
    </div>
    <div id="itmes"></div>
  </div>
</template>
<script>
import * as PDF from "pdfjs-dist";
import entry from "../assets/js/pdfjs/pdf.worker.entry";

import move from "@/assets/js/move";

const getPosition = function (obj) {
  var el = obj.getBoundingClientRect();
  var top = el.top - document.documentElement.clientTop + document.documentElement.scrollTop, //document.documentElement.clientTop 在IE67中始终为2，其他高级点的浏览器为0
    bottom = el.bottom,
    left = el.left - document.documentElement.clientLeft + document.documentElement.scrollLeft, //document.documentElement.clientLeft 在IE67中始终为2，其他高级点的浏览器为0
    right = el.right,
    width = el.width || right - left, //IE67不存在width 使用right - left获得
    height = el.height || bottom - top;

  return {
    y: top,
    right: right,
    bottom: bottom,
    x: left,
    width: width,
    height: height,
  };
};
const getScroll = function (direction, el) {
  if (el) {
    return el[direction] || el[direction];
  }
  return document.body[direction] || document.documentElement[direction];
};

let container, chapterEl, handelMove, itmesEl;
export default {
  name: "dg-pdfpreview",
  props: {
    value: String,
    chapter: String,
    show: Boolean,
   
  },
  watch: {
    chapter: {
      handler(val) {
        this.chapter_ = val;
      },
      immediate: true,
    },

    show: {
      handler(val) {
        if (val && handelMove) {
          handelMove.setElPosition(handelMove.getScrollInfo.scrollTop + 150, handelMove.getScrollInfo.scrollLeft + 150);
        }
      },
      immediate: true,
    },
  },

  data() {
    return {
      data: {
        pdfScale: 1, // 放大倍数
      },
      showLoading: false,
      numPages: 0,
      chapter_: 0,
      fromItemArr: {},
      itmeRegion: [],
      previewMin: [],
    };
  },

  methods: {
    loadFile(url) {
      // let loading = this.$loading({
      //   lock: true,
      //   text: '文件加载中...',
      //   spinner: 'el-icon-loading',
      //   background: 'rgba(0, 0, 0, 0.7)'
      // });
      this.showLoading = true;
      let loadingTask = PDF.getDocument(url);
      loadingTask.promise
        .then((pdf) => {
          this.numPages = pdf.numPages;
          this.data.pdfDoc = pdf;
          this.renderScrollPdfPage(1);
          // loading.close();
          this.showLoading = false;
        })
        .catch(() => {
          this.showLoading = false;
        });
    },

    renderScrollPdfPage(num) {
      this.data.pdfDoc.getPage(num).then((page) => {
        let itme = document.createElement("div");
        let canvas = document.createElement("canvas");
        itme.className = "item";
        canvas.id = "scrollPdfCanvas" + num;
        canvas.className = "pdf-container";
        itme.appendChild(canvas);
        itmesEl.appendChild(itme);
        let handleCanvas = document.getElementById("scrollPdfCanvas" + num.toString());
        let viewport = page.getViewport(996 / page._pageInfo.view[2]);
        this.data.pdfScale = viewport.scale;
        handleCanvas.height = viewport.height;
        handleCanvas.width = viewport.width;
        let ctx = handleCanvas.getContext("2d");

        this.previewMin.push(handleCanvas);
        let renderContext = {
          canvasContext: ctx,
          viewport: viewport,
        };

        page.render(renderContext).then(() => {
          try {
            if (num < this.numPages) {
              this.renderScrollPdfPage(num + 1);
            } else {
              // 给章添加移动事件
              handelMove = new move({
                wrapEl: document.getElementById("preview"),
                el: document.getElementById("chapter"),
                scrollHeiht: itmesEl.offsetHeight,
              });
              // 保存每页pdf 元素
              this.fromItemArr = Array.from(itmesEl.getElementsByClassName("item"));
              this.fromItemArr.forEach((el) => {
                if (el) {
                  this.itmeRegion.push(this.getRegionY(el));
                }
              });
              // 渲染缩略图
              this.$emit("renderComplete", {
                previewMin: this.previewMin,
                numPages: this.numPages,
              });
            }
          } catch (e) {
            console.log(e);
          }
        });
      });
    },

    handleSael() {
      let x = getPosition(chapterEl).x - getPosition(container).x + getScroll("scrollLeft", container);
      let y = getPosition(chapterEl).y - getPosition(container).y + getScroll("scrollTop", container);
      let index = this.getRegionIndex(this.itmeRegion, y);
      var ratioX = (x / getPosition(container).width).toFixed(4);
      var ratioY = ((y - this.itmeRegion[index].min) / getPosition(this.fromItemArr[index]).height).toFixed(4);
      let resultXY = [];
      this.fromItemArr.forEach((el, index) => {
        resultXY.push({
          ...this.getAbsolute(el, {
            x: Number(ratioX),
            y: Number(ratioY),
          }),
          // isRatable: true,
          // posx:ratioX,
          // posy:ratioY,
          pageNo: index + 1,
        });
      });
      if (this.show) {
        this.$emit("submit", resultXY);
      }
    },

    getRegionY(el) {
      let edgeY = getPosition(container).y; // 边缘的坐标y
      let min = parseInt(getPosition(el).y - edgeY + "");
      let max = parseInt(getPosition(el).y + getPosition(el).height - edgeY + "");
      return { min, max };
    },
    //定位
    offsetTop(index) {
      let itemEL = container.getElementsByClassName("item");
      container.scrollTop = itemEL[index].offsetTop;
    },
    // 根据百分比坐标，生产每页的绝对位置
    getAbsolute(el, ratio) {
      let { width, height } = getPosition(el);
      return {
        posx: Number(((width * ratio.x) / this.data.pdfScale).toFixed(4)),
        posy: Number(((height * ratio.y) / this.data.pdfScale).toFixed(4)),
      };
    },
    //  获取区间索引
    getRegionIndex(regions, y) {
      let i = 0;
      for (; i < regions.length; i++) {
        if (y >= regions[i].min && y <= regions[i].max) {
          break;
        }
      }
      return i;
    },
  },
  mounted() {
    container = document.getElementById("preview");
    itmesEl = document.getElementById("itmes");
    chapterEl = document.getElementById("chapter");

    PDF.GlobalWorkerOptions.workerSrc = entry;
    this.loadFile(this.value);

    Mirror.watch("loading_dg_pdfpreview", (key, value) => {
      this.showLoading = value;
      handelMove.stop = value;
    });
  },
};
</script>
<style lang="less" scoped>
@import "~@/assets/css/var.less";
#preview {
  width: 1000px;
  height: 85vh;
  overflow-y: auto;
  margin: 0 auto;
  position: relative;

  .chapter {
    width: 168px;
    height: 168px;
    /* border: 1px solid red; */
    position: absolute;
    left: 0;
    right: 0;
    z-index: 10;
    cursor: pointer;

    img {
      width: 100%;
      height: 100%;
      display: inline-block;
    }
  }
}
</style>
 <style></style>